module.exports = "<ota-dialog class=\"dialog-special-day\">\n  <div class=\"dialog-notify-content\">\n    <a href={{URI}} target=\"_blank\">\n      <img *ngIf=\"!isMobile\" class=\"alert-img\" src=\"{{ImageURI}}/act-special-day.jpg\" />\n      <img *ngIf=\"isMobile\" class=\"alert-img\" src=\"{{ImageURI}}/act-special-day-m.jpg\" />\n    </a>\n  </div>\n</ota-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-special-day/dialog-special-day.component.html
// module id = 1071
// module chunks = 22